import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';

export default function Details({ collection }) {
  return (
    <>
      {collection.map((record) => (
        <Row key={record.title} className="mb-4">
          <Col md={4} xl={3} className="mb-3 mb-md-0">
            <IconWithText
              iconClassName={record.icon}
            >
              <>
                <h6 className="mb-1">{record.title}</h6>

                <small className="text-gray-700 fw-light">
                  {record.label}
                </small>
              </>
            </IconWithText>
          </Col>

          <Col md={8} xl={9}>
            <h6>{record.label}</h6>

            <p>{record.description}</p>
          </Col>
        </Row>
      ))}
    </>
  );
}

Details.propTypes = {
  collection: PropTypes.arrayOf(PropTypes.object).isRequired,
};
